import React, { useEffect, useState } from "react";
import { MainSidebar } from "../mainsidebar/ui/buttonsNavigate";
import { Layout as AntLayout, theme } from "antd";
import { Outlet, useNavigate } from "react-router-dom";
import { getCookie, setCookie } from "typescript-cookie";
import MainNavBar from "../navbar";
import { useSelector } from "react-redux";
import { getAuthState } from "../../redux/slices/authSlice";
import AutoLogout from "../AutoLogout";

// import AutoLogout from "../AutoLogout";

const themes = {
  light: "../light-theme.css",
  dark: "../dark-theme.css",
};


export const MainLayout = () => {
  const currentTheme = getCookie("theme");
  const [sidebarCollapsed, setSidebarCollapsed] = useState<boolean>(false);
  const {  passwordChangeNextLogon } = useSelector(getAuthState);
  const navigate = useNavigate();

  useEffect(()=>{
     if(passwordChangeNextLogon === true){
      navigate('/changepasswordpage');
     }
  },[passwordChangeNextLogon])

  const handleToggleSidebar = () => {
    setSidebarCollapsed(prev => !prev);
  };
  
  const handleToggle = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  useEffect(() => {
    setCookie("theme", currentTheme || "light");
  }, [currentTheme]);

  return (
    <>
      <AntLayout
        hasSider
        style={{
          minHeight: "100vh",
          height: "100vh",
          overflow: "hidden"
        }}
      >
        <AutoLogout />
        <MainSidebar collapsed={sidebarCollapsed} onToggle={handleToggle} />
        <MainNavBar 
          collapsed={sidebarCollapsed}
          onToggle={handleToggleSidebar}
        />
        <AntLayout>
          <AntLayout.Content
            style={{
              background: colorBgContainer,
              borderRadius: borderRadiusLG,
              overflow: "auto",
              // height: "calc(100vh - 50px)",
              marginTop: "50px",
              position: "relative"
            }}
          >
            <Outlet />
          </AntLayout.Content>
        </AntLayout>
      </AntLayout>
    </>
  );
};
